// removed by extract-text-webpack-plugin
module.exports = {"packageIcon":"_2ZKkJBTnEsqLtP0JK1QIsk","iconLabel":"QF8Fzj60BYo86yGjfA-w2","disabled":"_11BoCXgaZAZeVSfuxAKvJ7","delimiter":"_2XIdxqCy6dOq_Ni7tGz4ys","tooltipMessage":"_366fb-IXAAwmzKb_rHi0px"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PackagePromotion/PackagePromotion.scss
// module id = 1689
// module chunks = 0